export const BASE_PATH =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : window.location.origin;